import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  possibleDiscount: {
    id: 'pd.loyalty.discount.possible.discount',
    defaultMessage: 'Chci slevu {value}',
  },
  customerDiscountBold: {
    id: 'pd.loyalty.discount.customer.discount.bold',
    defaultMessage: 'Vaše sleva {value}',
  },
  customerDiscount: {
    id: 'pd.loyalty.discount.customer.discount',
    defaultMessage:
      '{customerDiscountBold} na {subjectType} {discountSubject} se uplatní v košíku. {more}',
  },
  moreDiscountInfo: {
    id: 'pd.loyalty.discount.more.discount.info',
    defaultMessage: 'Více',
  },
  categoryDiscount: {
    id: 'pd.loyalty.discount.category.discount',
    defaultMessage: 'kategorii',
  },
  brandDiscount: {
    id: 'pd.loyalty.discount.brand.discount',
    defaultMessage: 'značku',
  },
});
